import { Box, FormHelperText, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment';
import { nanoid } from 'nanoid';
import React from 'react';
import DayAndTime from './timingComponents/DayAndTime';

export default function ClassTimingBox({ weeksList, setWeeksList, error }) {
  /**
   * This function is used for select day and add one slot by default.
   * And if day is selected then unselect and remove all slots.
   * @param {string} id
   */
  const handleDaySelection = (id) => {
    const newlist = [...weeksList].map((wl) => {
      if (wl._id === id) {
        if (wl.selected) {
          wl.selected = false;
          wl.slots = [];
        } else {
          const nearest15MinuteInterval = moment().add(15 - (moment().minute() % 15), 'minutes');
          wl.selected = true;
          wl.slots = [
            {
              _id: nanoid(10),
              from: nearest15MinuteInterval.toISOString(),
              to: nearest15MinuteInterval.add(45, 'minutes').toISOString()
            }
          ];
        }
      }
      return wl;
    });

    setWeeksList(newlist);
  };

  /**
   * Add new timing slot to particular day
   * @param {string} dayId
   */
  const handleAddSlot = (dayId) => {
    const newlist = [...weeksList].map((wl) => {
      if (wl._id === dayId) {
        const nearest15MinuteInterval = moment().add(15 - (moment().minute() % 15), 'minutes');
        wl.slots.push({
          _id: nanoid(10),
          from: nearest15MinuteInterval.toISOString(),
          to: nearest15MinuteInterval.add(45, 'minutes').toISOString()
        });
      }
      return wl;
    });

    setWeeksList(newlist);
  };

  /**
   * Remove particular slot from day.
   * @param {string} dayId
   * @param {string} slotId
   */
  const handleRemoveSlot = (dayId, slotId) => {
    const newlist = [...weeksList].map((wl) => {
      if (wl._id === dayId) {
        wl.slots = wl.slots.filter((sl) => sl._id !== slotId);
      }
      return wl;
    });

    setWeeksList(newlist);
  };

  /**
   * Update timing in particular slot.
   * @param {string} dayId
   * @param {string} slotId
   * @param {object} dateObj
   */
  const handleUpdateSlot = (dayId, slotId, dateObj) => {
    const newlist = [...weeksList].map((wl) => {
      if (wl._id === dayId) {
        wl.slots = wl.slots.map((sl) => {
          if (sl._id === slotId) {
            sl.from = dateObj.from;
            sl.to = dateObj.to;
          }
          return sl;
        });
      }
      return wl;
    });

    setWeeksList(newlist);
  };

  return (
    <Box mt={1} p={1}>
      <Box>
        <Typography fontWeight="bold">Class Timing</Typography>
        {error && <FormHelperText sx={{ color: 'red' }}>*Timing is necessary</FormHelperText>}
      </Box>
      {weeksList.map((wl) => (
        <DayAndTime
          key={wl._id}
          dayObj={wl}
          onDaySelection={handleDaySelection}
          addSlot={handleAddSlot}
          removeSlot={handleRemoveSlot}
          updateSlot={handleUpdateSlot}
        />
      ))}
    </Box>
  );
}

ClassTimingBox.propTypes = {
  weeksList: PropTypes.array,
  setWeeksList: PropTypes.func,
  error: PropTypes.bool
};
